import React from 'react'
const GreenPoint = () => {
	return (
        <div
            style={{
                display: "inline-block",
                backgroundColor: "green",
                height: "6px",
                width: "6px",
                borderRadius: "50%",
				marginRight: "6px",
				marginBottom:'2px'
            }}
        ></div>
    );
}

export default GreenPoint;


// WEBPACK FOOTER //
// ./src/scenes/reportes/components/GreenPoint.js